import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

import RecentWorkSum from "./RecentWorkSum";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import AboutUs from "./about-us/AboutUs";
import WhatWeDo from "./what-we-do/whatWeDo";
import HowWeWork from "./how-we-work/HowWeWork";
import WeWorkedWith from "./we-worked-with/WeWorkedWith";
import MobileMenu from "./mobile-menu/mobileMenu";

class Home extends Component {
  state = {
    showMobileMenu: false,
    companiesWeWorkedWith: {
      lines: [
        [
          { name: "B&H Photo", class: "bhp" },
          { name: "Maven software", class: "maven" },
          { name: "New york fulfilment", class: "nyf" },
          { name: "Lease it", class: "lsit" },
          { name: "EZ energy", class: "eze" },
          { name: "Salesforce", class: "crm" }
        ],
        [
          { name: "Gold nutrition clinic", class: "gnc" },
          { name: "Solution zone", class: "solz" },
          { name: "Acuman solutions", class: "acmn" },
          { name: "Metrex realty", class: "mtrr" },
          { name: "A&M judaica", class: "amj" }
        ],
        [
          { name: "Converge funding", class: "cnf" },
          { name: "Conect books", class: "cnctb" },
          { name: "Taubers fish", class: "tsf" },
          { name: "Tetech", class: "ttch" },
          { name: "Move rite", class: "mvrt" },
          { name: "EMB phones", class: "embp" }
        ],
        [
          { name: "TechBe", class: "tcb" },
          { name: "HVFA", class: "hvfa" },
          { name: "Braun P&H", class: "bph" },
          { name: "Le chapeau", class: "lechp" },
          { name: "Nite lite", class: "ntlt" }
        ],
        [
          { name: "Snips", class: "snps" },
          { name: "Pay essentails", class: "payes" },
          { name: "Zazosell", class: "zzs" },
          { name: "Spendless", class: "spndls" },
          { name: "Metrex groups", class: "mgs" },
          { name: "Off 16", class: "off16" }
        ],
        [
          { name: "Excore", class: "excr" },
          { name: "A&B floors", class: "abflr" },
          { name: "Ceasefire", class: "csfr" },
          { name: "U capture", class: "ucp" },
          { name: "Better bow", class: "btrb" }
        ]
      ]
    }
  };

  toggleMobileMenu = () => {
    this.setState({ showMobileMenu: !this.state.showMobileMenu });
  };
  render() {
    return (
      <div className="cntnt_wrpr tnx">
        <header className="main_hdr">
          <div className="icon_wrpr logo" />
          <div
            className="mobile_nav_opnr"
            onClick={() => {
              this.toggleMobileMenu();
            }}
          />
          <div className="nav_wrpr">
            {/* active */}

            <NavLink
              className="tlg nav_sec"
              smooth
              to="/#home"
              activeClassName="selected"
            >
              Home
            </NavLink>
            <NavLink
              className="tlg nav_sec"
              smooth
              to="/#about-us"
              activeClassName="selected"
            >
              About
            </NavLink>

            <NavLink
              className="tlg nav_sec"
              smooth
              to="/#services"
              activeClassName="selected"
            >
              Services
            </NavLink>

            <NavLink
              className="tlg nav_sec"
              smooth
              to="/#process"
              activeClassName="selected"
            >
              Process
            </NavLink>

            <Link className="tlg nav_sec" smooth to="/portfolio">
              Work
            </Link>

            <NavLink
              className="tlg nav_sec"
              smooth
              to="/#contact"
              activeClassName="selected"
            >
              Contact
            </NavLink>
          </div>
        </header>
        <div className="scroll_wrpr">
          <div className="landing_wrpr" id="home">
            <div className="ib left_sec">
              <div className="innr_cntnt_wrpr">
                <div className="text_wrpr">
                  {/* 
                  We design beautiful
interfaces, brands
and experiences. */}
                  <p className="bf tgrn hdr">
                    We design beautiful interfaces,
                    <span
                      className="mobile_only"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {" "}
                      brands and
                    </span>{" "}
                    <span className="mobile_hide"> brands and </span>
                    experiences.
                  </p>
                  <p className="tmg bslf txt mobile_hide">
                    We are a team of expert designers, web developers, and
                    software programmers. providing custom designed enterprise
                    business systems, branding websites, and media marketing.
                  </p>
                  <div className="social_wrpr mobile_hide">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/omediadesign/"
                    >
                      <div className="ib social_item icon_wrpr linkdn" />
                    </a>

                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://dribbble.com/OmediaDesign"
                    >
                      <div className="ib social_item icon_wrpr drbl" />
                    </a>

                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/omedia_design/"
                    >
                      <div className="ib social_item icon_wrpr inst" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="ib right_sec">
              <div className="innr_cntnt_wrpr" />
            </div>
            <p className="tmg bslf txt mobile_only">
              We are a team of expert designers, web developers, and software
              programmers. providing custom designed enterprise business
              systems, branding websites, and media marketing.
            </p>

            <div className="df spclty_list_wrpr mobile_only">
              <div className="itm ux" />
              <div className="itm csft" />
              <div className="itm mbl_app" />
              <div className="itm b_and_m" />
            </div>
            <div className="df arrowt_wrpr mobile_only">
              <div className="down_arrow" />
            </div>
          </div>
          <AboutUs />
          <WhatWeDo />
          <HowWeWork />
          <WeWorkedWith companies={this.state.companiesWeWorkedWith} />
          <RecentWorkSum />
          <ContactUs />
          <Footer />
        </div>
        {this.state.showMobileMenu ? (
          <MobileMenu
            hide={this.toggleMobileMenu}
            toggleMobileMenu={this.toggleMobileMenu}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(null, actions)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js